import { ConfigurationMapper } from './configuration';
import { EmailDocumentFieldOption, EmailDocument } from '../../../models';
import {
  EmailDocumentFieldOptionResponse,
  EmailDocument as OctopusEmailDocument,
} from '../models';

export class EmailDocumentMapper extends ConfigurationMapper<
  OctopusEmailDocument,
  EmailDocument
> {
  from(source: OctopusEmailDocument): EmailDocument {
    return {
      id: source.Key ?? '',
      name: source.Name,
      binaryDataId: source.BinaryDataId,
      dateTime: new Date(source.DateTime),
      size: source.Size,
      parentKey: source.ParentKey,
      description: source.Description ?? '',
      result: source.Result ?? null,
      category: source.Category ?? null,
      readAccess: source.SecAccess?.Read[0].Key.Value ?? '',
      fullAccess: source.SecAccess?.Write[0].Key.Value ?? '',
    };
  }
}

export class EmailDocumentFieldOptionMapper extends ConfigurationMapper<
  EmailDocumentFieldOptionResponse,
  EmailDocumentFieldOption
> {
  from(source: EmailDocumentFieldOptionResponse): EmailDocumentFieldOption {
    const emailDocument = source.EmailDocument?.FieldOptions;

    return {
      result: emailDocument?.Result?.map(this.mapValueAndDisplay) ?? [],
      category: emailDocument?.Category?.map(this.mapValueAndDisplay) ?? [],
      readAccess:
        emailDocument?.SecAccess?.Read?.map(this.mapSecurityAccess) ?? [],
      fullAccess:
        emailDocument?.SecAccess?.Write?.map(this.mapSecurityAccess) ?? [],
    };
  }
}
